import React from "react";
import StickyHeader from "../Navbar/StickyHeader";
import Home from "../Home/Home";

import SkillsDiv from "./110SkillsDiv";
import GalleryCertificates from "./220GalleryCertificates";
import ProjectGlimpse from "./300ProjectGlimpse";
import Experience_one from "./410Experience";
import Awards from "./500Awards";

import Achievementss from "./600Achievements";
import OpenSource from "./700OpenSource";
import ExtraActivity from "./800ExtraActivity";
import Education from "./900Education";

const Profile = () => {

    const my = 20;

    return (
        <>

            <Home />

            <StickyHeader />

            <div id="section1" className={`section my-${my}`}>
                <SkillsDiv />
            </div>

            <div id="section2" className={`section my-${my}`}>
                <ProjectGlimpse />
            </div>

            <div id="section3" className={`section my-${my}`}>
                <Experience_one />
            </div>

            <div id="section4" className={`section my-${my}`}>
                <Education />
            </div>

            <div id="section5" className={`section my-${my}`}>
                <GalleryCertificates />
            </div>
            
            <div id="section6" className={`section my-${my}`}>
                <Achievementss />
            </div>

            <div id="section7" className={`section my-${my}`}>
                <OpenSource />
            </div>

            <div id="section8" className={`section my-${my}`}>
                <Awards />
            </div>

            <div id="section9" className={`section my-${my}`}>
                <ExtraActivity />
            </div>
        </>
    );
};

export default Profile;
